import { RouteUpdateArgs } from 'gatsby'

import './src/styles/global.css'
import './src/styles/generated.css'

export const onRouteUpdate = ({
  location,
  prevLocation,
}: {
  location: RouteUpdateArgs['location']
  prevLocation: RouteUpdateArgs['prevLocation']
}) => {
  // document.title workaround stolen from:
  // https://github.com/gatsbyjs/gatsby/blob/master/packages/gatsby-plugin-google-analytics/src/gatsby-browser.js

  const sendPageView = () => {
    // to avoid sending analytics when adding # in url
    if (prevLocation && location.pathname === prevLocation.pathname && location.search === prevLocation.search) {
      return
    }
  }

  if ('requestAnimationFrame' in window) {
    requestAnimationFrame(() => {
      requestAnimationFrame(sendPageView)
    })
  } else {
    // simulate 2 rAF calls
    setTimeout(sendPageView, 32)
  }

  setTimeout(() => {
    performGatsbyPluginImageFix()
  }, 200)
}

/**
 * There is a bug in gatsby-plugin-image that causes images to have opacity: 0 even after they finish loading.
 * I couldn't find anything online about it, so this is the only solution I could devise to remedy this.
 */
function performGatsbyPluginImageFix() {
  const pictures = document.querySelectorAll('picture')
  for (const picture of pictures) {
    const img = picture.querySelector('img')
    if (img) {
      img.style.opacity = '1'
    }
  }
}
